import * as React from 'react';
import {
	AutocompleteInput,
	Create,
	CreateProps,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import { MediaInput } from '../components/MediaInput';
import { ELanguage } from '../enums';

export const SuccessStoryCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<MediaInput step={1} source="featuredImageUrl" label="IMAGE_OR_VIDEO" required={true}/>
				<TextInput step={1} source="title" label="TITLE" required={true}/>
				<TextInput multiline step={1} source="description" label="DESCRIPTION" required={true}/>
				<ReferenceInput
					step={1}
					label="CATEGORY"
					source="categoryId" reference="success-story-categories"
					alwaysOn
				>
					<AutocompleteInput optionText="name"/>
				</ReferenceInput>

				<ReferenceInput
					step={1}
					label="CREATED_BY"
					source="createdById" reference="clients"
					alwaysOn
				>
					<AutocompleteInput optionText="fullName"/>
				</ReferenceInput>

				<UploadImage step={1} source="gallery" label="GALLERY"/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Create>
	);
};
